import React from 'react'

export default function Nav() {
  return (
    <div>
      <nav>
        <a href="/" className="logo">Choicer</a>
        <ul>
          <li><span>Made With 💜 </span>By Hassan Ezz</li>
        </ul>
      </nav>

      <div className="overlay"></div>
    </div>
  )
}
